// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"25":"ea955de8","221":"8b448cea"}[chunkId] + ".chunk.css";
};